import { useUserProvider } from '@/context/UserProvider';
import { useEffect, useState } from 'react';
import { getInsStoryDashboardData } from '@/lib/service/dashboard';

export default function useStoryPremium() {
  const { isLogin } = useUserProvider();
  const [list, setList] = useState([]);

  useEffect(() => {
    if (!isLogin) {
      setList([]);
    } else {
      getInsStoryDashboardData().then((res) => {
        setList(res?.data || []);
      });
    }
  }, [isLogin]);

  return {
    isPremium: !!(isLogin && list?.length),
  };
}
